import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Stack, Box } from '@mui/material'

import {Header} from 'components/Modal';

import StepOtrumWarning from './StepOtrumWarning'
import ModelSteps, { Slider } from './components';
import { useRoom } from '../../use-rooms'
import { useSync } from './hooks'
import { trackEvent } from 'analytics'

const Samsung = ({ deviceType, device, psk, pin }) => {
  const [step, setStep] = useState(0)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const room = useRoom()
  const [syncTvsMacAddress, { loading: loadingSync }] = useSync()
  const titles = useMemo<string[]>(() => {
    return [
      deviceType === 'old' ? t('stream-cast.config.samsung.block_0_title') : null,
      t('stream-cast.config.samsung.block_1_title'),
      t('stream-cast.config.samsung.block_2_title'),
      t('stream-cast.config.samsung.block_3_title'),
      t('stream-cast.config.otrum_warning_title'),
      t('stream-cast.config.otrum_title')
    ].filter(Boolean) as string[]
  }, [deviceType])
  const steps = useMemo<string[]>(() => {
    return [
      deviceType === 'old' ? t('stream-cast.config.samsung.block_0_old') : null,
      deviceType === 'new' && device.model_type !== 'orsay' ? t('stream-cast.config.samsung.block_1_new') : null,
      deviceType === 'new' && device.model_type === 'orsay' ? t('stream-cast.config.samsung.block_1_new_orsay') : null,
      deviceType === 'old' ? t('stream-cast.config.samsung.block_1_old') : null,
      device.wired ? t('stream-cast.config.samsung.block_2_wired') : t('stream-cast.config.samsung.block_2_wifi', { psk: psk, ssid: room?.ssid_name }),
      ['tizen', 'tizen6'].includes(device.model_type)
        ? t('stream-cast.config.samsung.block_3_tizen', { url: device.model_type === 'tizen6' ? 'https://setupmy.tv/tz6' : 'https://setupmy.tv' })
        : device.model_type === 'orsay'
          ? t('stream-cast.config.samsung.block_3_orsay')
          : t('stream-cast.config.samsung.block_3_tep'),
      'never_show_replace_by_warning_step',
      t('stream-cast.config.otrum', {pin, room: device.subroom ? `${device.room} | ${device.subroom}` : device.room})
    ].filter(Boolean) as string[];
  }, [])
  const isWarningStep = useMemo<boolean>(() => {
    return step === steps.length - 2
  }, [step, steps])

  const handleSelect = async(value: number) => {
    if (value === steps.length && room?.is_iot_format) {
      await syncTvsMacAddress();
    }
    if (value === steps.length) {
      trackEvent('stream_cast_config_completed', { manufacturer: 'samsung', device_type: deviceType })
      navigate('..')
    }
    setStep(value)
  }

  return (
    <Stack sx={{ width: 500, fontSize: 13 }}>
      <ModelSteps
        loading={loadingSync}
        nbSteps={steps.length}
        step={step}
        onSelect={handleSelect}
      >
        <Header icon={<i className="fa-solid fa-gear" />} title={titles[step] || ''} />
        {
          isWarningStep
            ? <StepOtrumWarning onValidate={() => setStep(prev => prev + 1)} />
            : <Box dangerouslySetInnerHTML={{ __html: steps[step] || '' }} />
        }
      </ModelSteps>
      <Slider nbSteps={steps.length} step={step} onSelect={setStep} />

    </Stack>
  )
}

export default Samsung